import { h, Component, ComponentChildren } from "preact";
import { Provider } from "react-redux";
import { WithReduxStoreProps } from "../../apps/data/reduxRuntime";
import { FLAG_USE_CONSOLE_LOGGER } from "../../foundation/constants";

interface Props extends WithReduxStoreProps {
    children: ComponentChildren;
}

class ReduxProvider extends Component<Props> {
    render() {
        const { children, reduxStore } = this.props;

        if (!reduxStore) {
            if (FLAG_USE_CONSOLE_LOGGER) {
                throw new Error("Missing redux store");
            }
            return;
        }

        return (
            <Provider store={reduxStore}>
                {children}
            </Provider>
        );
    }
}

export default ReduxProvider;
